import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ValuesGamePlayerCoreService } from './values-game-player-core.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [ValuesGamePlayerCoreService],
})
export class ValuesGamePlayerCoreModule {}
